// tslint:disable: max-line-length

import { ApiService } from '../../services/api_service';
import { ContextService } from '../../services/context_service';
import { Document, Font, Image, Page, pdf, Text, View } from '@react-pdf/renderer';
import { EnergieCockpitAuswahl } from './EnergieCockpitAuswahl';
import { EnergieCockpitBenchmarking } from './EnergieCockpitBenchmarking2';
import { EnergieCockpitEnergiedaten } from './EnergieCockpitEnergiedaten2';
import { EnergieCockpitHinweise } from './EnergieCockpitHinweise2';
import { EnergieCockpitVisualisierung } from './EnergieCockpitVisualisierung2';
import { getGewerk, getGewerkName } from '../../main/functions/getGewerk';
import { getLastDataYear } from './helper/getLastDataYear';
import { getReportConfigItem } from './helper/getReportConfigs';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { Md5 } from 'ts-md5/dist/md5';
import * as Moment from 'moment';
import { parsePdfSub2 } from './generisch/helper';
import * as React from 'react';
import { SectionStyle } from '../../helpers/SectionStyle';
// import './elements/StandortAuswahl.css';

interface EnergieCockpitProps extends React.ClassAttributes<any> {
    callbackPages?: (pageNumber: number, totalPages: number) => void;
    data: any;
    jahr?: number;
    onRoutingChange: (routing: any) => void;
    routing: any;
    setJSXdirect?: (content: JSX.Element) => void;
    standortName?: string;
    standortTid?: number;
}

interface EnergieCockpitState {
    dataItems: any[];
    isLoaded: boolean;
    isLoading: boolean;
    jahr: number;
    kennzahlSelected1: string;
    kennzahlSelected2: string;
    lastMd5: string;
    lastReportMd5: string;
    noDataDemo: boolean;
    standort: number;
    benchmarkingPdfData: JSX.Element;
    energiedatenPdfData: JSX.Element;
    visualisierungPdfData: JSX.Element;
}

export class EnergieCockpit extends React.Component<EnergieCockpitProps, EnergieCockpitState> {

    constructor(props: any) {
        super(props);

        const jahrMax = Moment().year();
        const jahrContext = this.props.jahr ? this.props.jahr : this.contextService.get('jahr_cockpit');
        const jahr = jahrContext || ((this.props.routing && this.props.routing.jahr) ? this.props.routing.jahr : getLastDataYear(jahrMax, this.props.data) || jahrMax);

        const standortContext = typeof this.props.standortTid !== 'undefined'
            ? this.props.standortTid
            : typeof this.contextService.get('standort_cockpit') !== 'undefined' ? this.contextService.get('standort_cockpit') : 0;
        this.state = {
            dataItems: undefined,
            isLoaded: false,
            isLoading: false,
            jahr,
            kennzahlSelected1: null,
            kennzahlSelected2: null,
            lastMd5: null,
            lastReportMd5: null,
            noDataDemo: false,
            standort: typeof standortContext === 'number'
                ? standortContext
                : ((this.props.data[IDs.ENT_STANDORT] || [])[0] || {}).tid || null,
            benchmarkingPdfData: null,
            energiedatenPdfData: null,
            visualisierungPdfData: null
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;

    private backgroundColorSectionTable: string;
    private report: any = {};

    componentDidMount(): void {
        if (this.props.setJSXdirect) {
            this.prepareDataItems();
        } else {
            this.setState({ lastMd5: this.getMd5() }, this.prepareDataItems);
        }
        this.setColors();
    }

    componentDidUpdate(): void {
        if (this.state.benchmarkingPdfData && this.state.energiedatenPdfData && this.state.visualisierungPdfData) {
            if (this.props.setJSXdirect) {
                this.report = this.getReportConfig();
                this.renderPdf();
            }
        }

        if (!this.props.setJSXdirect) {
            if (this.getMd5() !== this.state.lastMd5) {
                this.setState({ lastMd5: this.getMd5() }, this.prepareDataItems);
            }

            if (this.getReportMd5() !== this.state.lastReportMd5) {
                this.setState({ lastReportMd5: this.getReportMd5() }, () => this.report = this.getReportConfig());
            }
        }
    }

    getMd5(): string {
        const standort: number = this.state.standort || null;
        const kennziffern_berechnet: any = standort
            ? (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort] || {}
            : this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
        return Md5.hashAsciiStr(JSON.stringify(kennziffern_berechnet)).toString();
    }

    getReportConfig(): any {
        const contextReport: any = this.contextService.get('report_config') || {};
        const data: any[] = contextReport.useContext && Object.keys(contextReport.config || {}).length
            ? contextReport.config : null;

        return getReportConfigItem({
            data: data ? [{ konfiguration: data }] : (this.props.data || {})[IDs.ENT_REPORT] || [],
            standort: this.props.setJSXdirect ? this.props.standortTid : this.state.standort,
            key: 'energiecockpit'
        }) || {};
    }

    getReportMd5(): string {
        return Md5.hashAsciiStr(JSON.stringify(this.getReportConfig())).toString();
    }

    getStyle(): any {
        const containerId: string = typeof SectionStyle.curPrintSectionId === 'number' ? SectionStyle.getCurrentClass(true) : null;
        const colorSection: string = new SectionStyle(containerId).getPropertyValue('--color-section-main');

        return ({
            header: {
                fontSize: '18pt',
                fontFamily: 'Helvetica-Bold',
                color: '#555',
                width: '100%',
                height: 60,
                top: 0,
                left: 0,
                padding: 0,
                position: 'relative',
                display: 'block'
            },
            headerImage: {
                width: 'auto',
                // width: 241,
                height: 40,
                top: 0,
                right: 0,
                position: 'absolute',
                display: 'inline-block'
            },
            headerImageUnternehmen: {
                maxWidth: 80,
                height: 40,
                objectFit: 'contain',
                top: 0,
                right: 70,
                position: 'absolute'
            },
            headerText: {
            },
            headerSubText: {
                fontSize: '16pt',
                maxWidth: 500,
                color: colorSection || '#5e8bc2'
            },
            headerSubText2: {
                fontSize: '11pt',
                color: '#555',
                marginTop: 10
            },
            headerSubText3: {
                fontSize: '10pt',
                color: colorSection || '#6692c2'
            },
            footer: {
                fontSize: '8pt',
                right: 40,
                bottom: 15,
                left: 40,
                width: '100%',
                height: 'auto',
                padding: 0,
                position: 'absolute',
                display: 'block',
                boxSizing: 'border-box'
            },
            footerSeiten: {
                right: 0,
                position: 'absolute'
            },
            text: {
                fontSize: '12pt',
                textAlign: 'justify'
            },
            bemerkung: {
                fontFamily: 'Helvetica',
                fontSize: '9pt',
                margin: 0,
                padding: 0,
                paddingTop: 5,
                display: 'flex',
                flexDirection: 'row'
            },
            page: {
                padding: 40,
                paddingTop: 20,
                paddingBottom: 20
            }
        });
    }

    prepareDataItems(): void {
        const jahr = this.state.jahr;
        let msg_jahr = '';
        let msg_vorjahr = '';
        const vorjahr = jahr - 1;
        const standort = this.state.standort;
        const kz_berechnet = standort
            ? (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort] || {}
            : this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
        const kz_jahr = kz_berechnet[jahr] || {};
        const kz_vorjahr = kz_berechnet[vorjahr] || {};
        const hasData = (value: any): boolean => Object.keys(kz_vorjahr).length && typeof value === 'number' && !isNaN(value) && value > 0;
        const sum_v_jahr = (kz_jahr.strom_verbrauch_fremdbezug || 0) + (kz_jahr.eigenstrom_verbrauch_kwh || 0) + (kz_jahr.waerme_kwh || 0)
            + (kz_jahr.kraftstoff_kwh || 0);
        const sum_k_jahr = (kz_jahr.strom_kosten_gesamt || 0) + (kz_jahr.kosten_waerme || 0) + (kz_jahr.kraftstoffe_kosten || 0);
        const sum_c_jahr = (kz_jahr.co2_strom_precalc || 0) + (kz_jahr.co2_waerme || 0) + (kz_jahr.co2_kraftstoffe || 0);
        const sum_v_vorjahr = Object.keys(kz_vorjahr).length
            ? (kz_vorjahr.strom_verbrauch_fremdbezug || 0) + (kz_vorjahr.eigenstrom_verbrauch_kwh || 0) + (kz_vorjahr.waerme_kwh || 0) + (kz_vorjahr.kraftstoff_kwh || 0)
            : null;
        const sum_k_vorjahr = Object.keys(kz_vorjahr).length
            ? (kz_vorjahr.strom_kosten_gesamt || 0) + (kz_vorjahr.kosten_waerme || 0) + (kz_vorjahr.kraftstoffe_kosten || 0)
            : null;
        const sum_c_vorjahr = Object.keys(kz_vorjahr).length
            ? (kz_vorjahr.co2_strom || 0) + (kz_vorjahr.co2_waerme || 0) + (kz_vorjahr.co2_kraftstoffe || 0)
            : null;
        // Messages
        if (+kz_jahr.eigenstrom_verbrauch_kwh > 0) {
            msg_jahr = i18n('Gesamt-Stromverbrauch: Versorgerstrom + eigene Erzeugung', 'sys');
        }
        if (+kz_vorjahr.eigenstrom_verbrauch_kwh > 0) {
            msg_vorjahr = i18n('Gesamt-Stromverbrauch: Versorgerstrom + eigene Erzeugung', 'sys');
        }
        const items = [
            {
                name: i18n('Strom', 'sys'),
                v_jahr: (kz_jahr.strom_verbrauch_fremdbezug || 0) + (kz_jahr.eigenstrom_verbrauch_kwh || 0),
                v_vorjahr: (hasData(kz_vorjahr.strom_verbrauch_fremdbezug) && hasData(kz_vorjahr.eigenstrom_verbrauch_kwh))
                    ? kz_vorjahr.strom_verbrauch_fremdbezug + kz_vorjahr.eigenstrom_verbrauch_kwh
                    : hasData(kz_vorjahr.strom_verbrauch_fremdbezug)
                        ? kz_vorjahr.strom_verbrauch_fremdbezug
                        : hasData(kz_vorjahr.eigenstrom_verbrauch_kwh) ? kz_vorjahr.eigenstrom_verbrauch_kwh : null,
                k_jahr: kz_jahr.strom_kosten_gesamt || 0,
                k_vorjahr: hasData(kz_vorjahr.strom_kosten_gesamt) ? kz_vorjahr.strom_kosten_gesamt : null,
                msg_jahr,
                msg_vorjahr,
                c_jahr: kz_jahr.co2_strom_precalc || 0, c_vorjahr: hasData(kz_vorjahr.co2_strom_precalc) ? kz_vorjahr.co2_strom_precalc : null
            },
            {
                name: i18n('Wärme', 'sys'),
                v_jahr: kz_jahr.verbrauch_waerme_kwh || 0,
                v_vorjahr: hasData(kz_vorjahr.verbrauch_waerme_kwh) ? kz_vorjahr.verbrauch_waerme_kwh : null,
                k_jahr: kz_jahr.kosten_waerme || 0, k_vorjahr: hasData(kz_vorjahr.kosten_waerme) ? kz_vorjahr.kosten_waerme : null,
                c_jahr: kz_jahr.co2_waerme || 0, c_vorjahr: hasData(kz_vorjahr.co2_waerme) ? kz_vorjahr.co2_waerme : null
            },
            {
                name: i18n('Kraftstoffe', 'sys'),
                v_jahr: kz_jahr.kraftstoff_kwh || 0, v_vorjahr: hasData(kz_vorjahr.kraftstoff_kwh) ? kz_vorjahr.kraftstoff_kwh : null,
                k_jahr: kz_jahr.kraftstoffe_kosten || 0,
                k_vorjahr: hasData(kz_vorjahr.kraftstoffe_kosten) ? kz_vorjahr.kraftstoffe_kosten : null,
                c_jahr: kz_jahr.co2_kraftstoffe || 0, c_vorjahr: hasData(kz_vorjahr.co2_kraftstoffe) ? kz_vorjahr.co2_kraftstoffe : null
            },
            {
                name: i18n('Gesamt', 'sys'),
                v_jahr: sum_v_jahr,
                v_vorjahr: (
                    !hasData(kz_vorjahr.strom_verbrauch_fremdbezug) && !hasData(kz_vorjahr.eigenstrom_verbrauch_kwh)
                    && !hasData(kz_vorjahr.verbrauch_waerme_kwh) && !hasData(kz_vorjahr.kraftstoff_kwh)
                )
                    ? null
                    : sum_v_vorjahr,
                k_jahr: sum_k_jahr,
                k_vorjahr: (
                    !hasData(kz_vorjahr.strom_kosten_gesamt) && !hasData(kz_vorjahr.kosten_waerme)
                    && !hasData(kz_vorjahr.kraftstoffe_kosten)
                )
                    ? null
                    : sum_k_vorjahr,
                c_jahr: sum_c_jahr,
                c_vorjahr: (!hasData(kz_vorjahr.co2_strom_precalc) && !hasData(kz_vorjahr.co2_waerme) && !hasData(kz_vorjahr.co2_kraftstoffe))
                    ? null
                    : sum_c_vorjahr
            }
        ];
        this.setState({ dataItems: items });
    }

    async processPdf(pdfData: JSX.Element): Promise<void> {
        if (this.props.setJSXdirect) {
            this.props.setJSXdirect(pdfData);
            return;
        }
        pdfData = <Document>{pdfData}</Document>;

        try {
            const blob = await pdf(pdfData).toBlob();
            const pdfString: string = URL.createObjectURL(blob);
            this.setState({ isLoading: false });
            const filename: string = (
                `${this.state.jahr} - ${i18n('Energiedaten', 'sys')}, ${i18n('Betriebsvergleich', 'sys')} ` +
                `[${(new Date()).toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' })}]` +
                '.pdf'
            );
            // const a = document.createElement('a');
            // a.target = '_blank';
            // a.title = filename;
            // a.href = pdfString;
            // a.download = filename;
            // document.body.appendChild(a);
            // a.click();
            // document.body.removeChild(a);
            saveAs(pdfString, filename);
        } catch (error) {
            console.log('error: ', error);
        }
    }

    render(): JSX.Element {
        const demo_img = require('../../img/CockpitBeispiel.jpg');
        const gewerk_tid = getGewerk(this.props.data);
        const standorte = this.props.data[IDs.ENT_STANDORT] || [];
        const count_items = standorte.filter((s: any) => s.energiedaten_erfassen_orig === 1 || s.energiedaten_erfassen === 1).length;
        const showCockpit = gewerk_tid && gewerk_tid > 0 && count_items > 0;
        const isAdmin = this.apiService.isAdmin();
        return <>
            {(false && showCockpit && isAdmin)
                ? <div style={{ /*margin: 5*/ }}>
                    <input
                        type='checkbox'
                        checked={this.state.noDataDemo}
                        onChange={(evt: any) => this.setState({ noDataDemo: evt.target.checked })}
                    />
                    <small style={{ color: '#aaa' }}>{i18n('Demo "Keine Daten vorhanden"', 'sys')}</small>
                </div>
                : null//<div style={{ marginTop: 5 }}></div>
            }
            {(!showCockpit || this.state.noDataDemo) && <div style={{ width: 800, margin: 10 }}><img src={demo_img} alt='' /></div>}
            {showCockpit && !this.state.noDataDemo && !this.props.setJSXdirect &&
                <div>
                    <EnergieCockpitAuswahl
                        data={this.props.data}
                        jahr={this.state.jahr}
                        onJahrChange={(jahr: number) => {
                            this.contextService.set('jahr_cockpit', +jahr);
                            this.setState({ jahr }, this.prepareDataItems);
                        }}
                        onPdfCreate={() => this.setState({ isLoading: true }, this.renderPdf)}
                        onRoutingChange={this.props.onRoutingChange}
                        onStandortChange={(standort: number) => {
                            this.contextService.set('standort_cockpit', standort);
                            this.setState({ standort }, this.prepareDataItems);
                        }}
                        standort={this.state.standort}
                    />
                </div>
            }
            {showCockpit && !this.state.noDataDemo &&
                <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 1300/*1296*/, padding: 0, boxSizing: 'border-box' }}>
                    {!this.props.setJSXdirect &&
                        <div style={{ marginTop: 20 }}>
                            <EnergieCockpitHinweise
                                onRoutingChange={this.props.onRoutingChange}
                                data={this.props.data}
                                jahr={this.state.jahr}
                            />
                        </div>
                    }
                    <div style={{ display: 'flex', flex: 1, flexDirection: 'row'/*, flexWrap: 'wrap'*/, margin: '20px 0 0 0' }}>
                        <div
                            style={{
                                backgroundColor: this.backgroundColorSectionTable || 'transparent', maxWidth: 640/*648*/, minWidth: 640/*648*/,
                                marginRight: 20/*-1*/, marginBottom: 20, borderRadius: '10px 10px 0 0', boxSizing: 'border-box',
                                display: 'flex', flex: 1, flexDirection: 'column'
                            }}
                        >
                            <EnergieCockpitEnergiedaten
                                data={this.props.data}
                                dataItems={this.state.dataItems}
                                jahr={this.state.jahr}
                                onJahrChange={(jahr: number) => {
                                    this.contextService.set('jahr_cockpit', +jahr);
                                    this.setState({ jahr }, this.prepareDataItems);
                                }}
                                onPdfDataLoaded={(data: any) => this.setState({ energiedatenPdfData: data || null })}
                                onRoutingChange={this.props.onRoutingChange}
                                routing={this.props.routing}
                            />
                        </div>
                        <div
                            style={{
                                backgroundColor: this.backgroundColorSectionTable || 'transparent', maxWidth: 640/*648*/, minWidth: 640/*648*/,
                                maxHeight: 600, marginBottom: 20, borderRadius: '10px 10px 0 0', boxSizing: 'border-box',
                                display: 'flex', flex: 1, flexDirection: 'column'
                            }}
                        >
                            <EnergieCockpitVisualisierung
                                data={this.props.data}
                                dataItems={this.state.dataItems}
                                jahr={this.state.jahr}
                                onPdfDataLoaded={(data: any) => this.setState({ visualisierungPdfData: data || null })}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', flex: 1, flexDirection: 'row'/*, flexWrap: 'wrap'*/ }}>
                        <EnergieCockpitBenchmarking
                            data={this.props.data}
                            jahr={this.state.jahr}
                            onKennzahlChange={(kennzahl: string) => this.setState({ kennzahlSelected1: kennzahl || null })}
                            onKennzahlChange2={(kennzahl: string) => this.setState({ kennzahlSelected2: kennzahl || null })}
                            onPdfDataLoaded={(data: any) => this.setState({ benchmarkingPdfData: data || null })}
                            standort={this.state.standort}
                        />
                    </div>
                </div>
            }
        </>;
    }

    renderReportBemerkung(): JSX.Element {
        if (!this.report.active || typeof this.report.bemerkung !== 'string') {
            return null;
        }
        const styles: any = this.getStyle();

        return (
            <View style={styles.bemerkung}>
                <Text>{this.report.bemerkung}</Text>
            </View>
        );
    }

    renderFooter(): JSX.Element {
        const styles: any = this.getStyle();

        return (
            <View style={styles.footer} fixed>
                <Text>{Moment().format('DD.MM.YYYY')}</Text>
                <View style={styles.footerSeiten}>
                    <Text
                        render={({ pageNumber, totalPages }) => {
                            if (typeof this.props.callbackPages === 'function' && totalPages) {
                                this.props.callbackPages(pageNumber, totalPages);
                            }

                            if (totalPages > 1) {
                                return `${pageNumber}/${totalPages}`;
                            }
                        }}
                        fixed
                    />
                </View>
            </View>
        );
    }

    renderHeader(): JSX.Element {
        // const header = require('../../img/logo_mittel2.png');
        const header = require('../../img/logo_section_datenauswertung.jpg');
        // const header = require('../../img/Logo.jpg');
        const headerUnternehmen = this.contextService.get('UNTERNEHMEN_LOGO_URL');
        // const kennzahlen: any[ = this.props.data[IDs.ENT_KENNZAHLEN_DEFINTION] || [];
        // const kennzahl: string = (kennzahlen.find((item: any) => item.kuerzel === this.state.kennzahlSelected1) || {}).name || null;
        // const kennzahl2: string = (kennzahlen.find((item: any) => item.kuerzel === this.state.kennzahlSelected2) || {}).name || null;
        const standort: string = ((this.props.data[IDs.ENT_STANDORT] || [])
            .find((item: any) => item.tid === this.state.standort) || {}).name || null;
        const styles: any = this.getStyle();
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;

        return (
            <View style={styles.header} fixed>
                <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                    <Text style={styles.headerText}>E-Tool:&nbsp;</Text>
                    <Text style={styles.headerSubText}>
                        {parsePdfSub2(unternehmen, styles.headerSubText)}
                    </Text>
                </View>
                <View style={{ ...styles.headerSubText2, display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                    <Text style={{ fontFamily: 'Calibri-Bold', lineHeight: 1.05 }}>
                        →&nbsp;
                    </Text>
                    <Text>{i18n('Energie-Cockpit', 'sys')}:&nbsp;</Text>
                    <Text style={{ ...styles.headerSubText3, margin: 0 }}>
                        {standort ? parsePdfSub2(`${i18n('Standort', 'sys')}: ${standort}`, styles.headerSubText3) : i18n('Gesamtunternehmen', 'sys')}
                    </Text>
                </View>
                {headerUnternehmen &&
                    <Image src={headerUnternehmen} style={styles.headerImageUnternehmen} />
                }
                <Image src={header} style={styles.headerImage} />
            </View>
        );
    }

    renderPdf(): void {
        const kennzahlen: any = this.state.standort
            ? (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT][this.state.standort] || {}) || {}
            : this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};

        if (
            ((kennzahlen.flags || {}).hasCO2 && (getGewerkName(this.props.data) || '').trim() === 'Kein Handwerk'
                || this.state.benchmarkingPdfData
            )
            && this.state.energiedatenPdfData && this.state.visualisierungPdfData
        ) {
            Font.register({ family: 'Calibri-Bold', src: require('../../font/calibri_regular.ttf') });
            const styles: any = this.getStyle();
            this.processPdf(
                <Page size='A4' orientation='landscape' style={styles.page}>
                    {this.renderHeader()}
                    <View style={{ marginBottom: 10, display: 'flex', flexDirection: 'row' }}>
                        {this.state.energiedatenPdfData}
                        {this.state.visualisierungPdfData}
                    </View>
                    {this.state.benchmarkingPdfData}
                    {this.renderReportBemerkung()}
                    {this.renderFooter()}
                </Page>
            );
        }
    }

    setColors(): void {
        this.backgroundColorSectionTable = new SectionStyle().getPropertyValue('--color-section-table-background');
    }
}
